import { Route } from 'react-router-dom';
import { CelloWidgetComponent } from 'src/components/baseComponents/CelloWidgetComponent';

export const getCelloWidgetRoutes = ({ isMinimized }) => {
  // if ( import.meta.env.VITE_CELLO_ENABLE === "true") {
  const pages = [
    {
      path: '/referral',
      Component: CelloWidgetComponent,
    },
  ];

  return pages.map((route, index) => {
    const { path, Component } = route;
    return (
      <Route
        key={index}
        path={path}
        element={<Component isMinimized={isMinimized} />}
      />
    );
  });
  // }
};
